import PropTypes from 'prop-types';
import React from 'react';
import isNil from 'lodash/isNil';
import { Trans } from 'react-i18next';

const ConfirmationScreenSection = ({ title, oldValue, newValue }) => {
  let text = (
    <p>
      <Trans
        i18nKey="appointment:confirmation.changed_from_to"
        values={{
          oldValue,
          newValue,
        }}
        components={{
          oldSpan: <span className="u-type--bold u-font-color-grey" />,
          newSpan: <span className="u-type--bold u-font-color-primary" />,
        }}
      />
    </p>
  );
  if (isNil(oldValue)) {
    text = (
      <p>
        <Trans
          i18nKey="appointment:confirmation.added_value"
          values={{ newValue }}
          components={{
            newSpan: <span className="u-type--bold u-font-color-primary" />,
          }}
        />
      </p>
    );
  }
  if (!newValue) {
    text = (
      <p>
        <Trans
          i18nKey="appointment:confirmation.deleted_value"
          values={{ oldValue }}
          components={{
            oldSpan: <span className="u-type--bold u-font-color-grey" />,
          }}
        />
      </p>
    );
  }
  return (
    <div className="layout__item u-pr">
      <div className="c-label c-label--light">{ title }</div>
      { text }
    </div>
  );
};

ConfirmationScreenSection.propTypes = {
  title: PropTypes.string.isRequired,
  oldValue: PropTypes.string.isRequired,
  newValue: PropTypes.string.isRequired,
};

export default ConfirmationScreenSection;
